var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"广告详情","visible":_vm.previewAds,"width":"900px","modal-append-to-body":false,"append-to-body":true},on:{"close":_vm.handleClose}},[_c('ad-format',{attrs:{"value":_vm.value}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }